import React from "react";
import {Heading, Text, Box, View} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";

import {IntlNamespaces} from "../../../../translations/types";
import {UnibuddyLogoInlineSvg} from "../../../../widgets/modules/RegisterNew/components/UnibuddyLogoInlineSvg";
import {ThemedLink} from "../../../../components/ThemedLink/ThemedLink";
import {INTL_SIGNIN} from "../../../../translations/login";
import {INTL_KNOW_YOUR_PASSWORD, INTL_RESET_PASSWORD} from "../../../../translations/passwordReset";

type ResetPasswordHeaderProps = {loginLink: string};

export function PasswordResetHeader({loginLink}: ResetPasswordHeaderProps) {
    const {t} = useTranslation([IntlNamespaces.PASSWORD_RESET, IntlNamespaces.VALIDATIONS]);

    return (
        <View gap="small-medium" alignItems="center" aria-live="polite">
            <UnibuddyLogoInlineSvg />
            <Heading size="xxsmall" level={1}>
                {t(INTL_RESET_PASSWORD.key, INTL_RESET_PASSWORD.defaultValue)}
            </Heading>
            <Box display="flex" alignItems="center">
                <Text size="small">
                    {t(INTL_KNOW_YOUR_PASSWORD.key, INTL_KNOW_YOUR_PASSWORD.defaultValue)}&nbsp;
                </Text>
                <ThemedLink
                    aria-label={t(INTL_SIGNIN.key, INTL_SIGNIN.defaultValue)}
                    to={loginLink}
                >
                    {t(INTL_SIGNIN.key, INTL_SIGNIN.defaultValue)}
                </ThemedLink>
            </Box>
        </View>
    );
}
